export default {
  saledFeedback: 'アフターサービスフィードバック',
  orderNo: 'オーダー番号',
  unreply: '返信なし',
  replied: '返信済み',
  apply: '申請',
  badImg: '不良画像',
  applyDetail: '申請の詳細',
  replyDate: '返信日',
  replyContent: '返信内容',
  orderMsg: '注文メッセージ',
  otherMsg: 'その他のメッセージ',
  clickUpload: 'アップロード',
  uploadRefreshTip: '全ての画像がアップロードされるのを待つかページを再読み込みし再度アップロードをお試し下さい',
  uploadNumberTip: '最大4枚の画像をアップロードできます',
  uploadNumberTip9: '最大9枚の画像をアップロードできます',
};
